import React, { useEffect, useState } from "react";
import Select from "react-select";

export const DocumentEditModal = ({
                                      fileName,
                                      visible,
                                      onConfirm,
                                      onCancel,
                                      fileTypeOptions,
                                      isEditMode = false,
                                      onDelete
                                  }: {
    fileName: string;
    visible: boolean;
    onConfirm: (name: string, fileType: string) => void;
    onCancel: () => void;
    fileTypeOptions: { value: string; label: string }[];
    isEditMode?: boolean;
    onDelete?: () => void;
}) => {
    const [name, setName] = useState("");
    const [selectedType, setSelectedType] = useState(fileTypeOptions[0]);

    useEffect(() => {
        setName(fileName);
    }, [fileName, fileTypeOptions]);

    if (!visible) return null;

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        if (name.trim() && selectedType) {
            onConfirm(name.trim(), selectedType.value);
            setName("");
        }
    };

    const handleCancel = () => {
        onCancel();
        setName("");
    };

    const handleDelete = () => {
        if (!onDelete) return;
        const confirmed = window.confirm("Are you sure you want to delete this file?");
        if (confirmed) {
            onDelete();
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 999,
            }}
        >
            <div
                style={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    minWidth: "300px",
                }}
            >
                <h4>{isEditMode ? "Redigera filen" : "Information om filen"}</h4>
                <form onSubmit={handleSubmit}>
                    <label style={{ display: "block", marginBottom: "6px", textAlign: "left" }}>
                        Namn
                    </label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={{ width: "100%", marginBottom: "10px" }}
                    />

                    <label style={{ display: "block", marginBottom: "6px", textAlign: "left" }}>
                        Kategori
                    </label>
                    <Select
                        options={fileTypeOptions}
                        value={selectedType}
                        onChange={(val) => {
                            if (val) setSelectedType(val);
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "8px",
                            marginTop: "16px",
                        }}
                    >
                        {isEditMode && onDelete && (
                            <button type="button" onClick={handleDelete} style={{ marginRight: "auto" }}>
                                Delete
                            </button>
                        )}

                        <button type="button" onClick={handleCancel}>
                            Avbryt
                        </button>
                        <button type="submit">
                            {isEditMode ? "Spara" : "Ladda upp"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
